module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/e61e13e2f960f722aab520347dca8b06.png";